import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  updateProfile: ['updateRequests'],
  updateProfileClear: null,
  updateProfileRequest: null,
  updateProfileSuccess: ['data'],
  updateProfileFailure: ['error']
});

export { Creators, Types };
